"use client";
import React, { FC } from "react";
import styles from "./Hero.module.css";
import Image from "next/image";

export type HeroImageProps = {
  imageUrl?: string;
  alt?: string;
  showBackgroundGradient?: boolean;
};

const defaultImage = "/images/hero-sdlc.svg";
const defaultAlt =
  "Software development lifecycle diagram showing planning, development, testing, and deployment phases";

const HeroImage: FC<HeroImageProps> = ({
  imageUrl = defaultImage,
  alt = defaultAlt,
  showBackgroundGradient = true,
}) => {
  return (
    <div className={`w-full ${showBackgroundGradient ? styles.heroImageBg : ""} ${styles.heroImage}`}>
      <Image
        className="mx-auto w-auto max-w-full"
        src={imageUrl}
        alt={alt}
        width={800}
        height={547}
        priority
      />
    </div>
  );
};

export default HeroImage;
